export default class Observable {
  private listeners = new Set<() => void>();

  notify() {
    this.listeners.forEach((v) => v());
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  unsubscribe(listener: () => void): boolean {
    return this.listeners.delete(listener);
  }
}
